import service from '@/api/service/service';
import qs from "qs";

/* 分类、难度 */
export function category_difficult(params = {}) {
  return service({
    url: "/api/plan/category_skill_list.json",
    method: 'get',
    params: params,
  });
}
/* 我的教案 */
export function myTutorial(params = {}) {
  return service({
    url: "/api/plan/my_plan_list.json",
    method: 'get',
    params: params,
  });
}
/* 资源库 */
export function allTutorial(data = {}) {
  return service({
    url: "/api/plan/library_list.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 教案详情 */
export function tutorialDetail(data = {}) {
  return service({
    url: "/api/plan/view_plan.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 优秀教案 */
export function excellentTutorial(data = {}) {
  return service({
    url: "/api/plan/recommend_excellent_plan.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 下载教案PDF */
export function downloadTutorial(data = {}) {
  return service({
    url: "/api/plan/view_pdf_download.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 删除教案 */
export function deleteTutorial(data = {}) {
  return service({
    url: "/api/plan/delete_plan.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 更改教案类型 */
export function tutorialType(data = {}) {
  return service({
    url: "/api/plan/update_plan_type.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 更改教案共享状态 */
export function tutorialStatus(data = {}) {
  return service({
    url: "/api/plan/update_sharing_status.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 获取需要测评的教师、机构
export function getStuRatingInfo(params = {}) {
  return service({
    url: '/api/evaluation/student_evaluation_data.json',
    method: 'get',
    params,
  })
}

// 保存评价的结果
export function saveEvaluat(data = {}) {
  return service({
    url: '/api/evaluation/stu_evaluation_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 判断学员的培训班是否测评了
export function isEvaluated(params = {}) {
  return service({
    url: '/api/evaluation/opinion_student_eva.json',
    method: 'get',
    params,
  })
}
// 到期学院资质提交
export function qualification_submit(data = {}) {
  return service({
    url: '/api/organization/qualification_submit.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
